module.exports = __webpack_public_path__ + "img/ditu.9b3f7aa9.png";